"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PartnerLinkTarget = exports.PartnerLinkTargets = void 0;
var entity_1 = require("./entity");
var indi_1 = require("./indi");
var PartnerLinkTargets;
(function (PartnerLinkTargets) {
    PartnerLinkTargets["Processor"] = "processor";
    PartnerLinkTargets["Dawn"] = "dawn";
    PartnerLinkTargets["Indi"] = "indi";
    PartnerLinkTargets["Widget"] = "widget";
    PartnerLinkTargets["IndiProduct"] = "indi_product";
    PartnerLinkTargets["ChronosPlus"] = "chronos_plus";
})(PartnerLinkTargets = exports.PartnerLinkTargets || (exports.PartnerLinkTargets = {}));
var PartnerLinkTarget = (function () {
    function PartnerLinkTarget(_target) {
        this._target = _target;
    }
    PartnerLinkTarget.fromKey = function (key) {
        return new PartnerLinkTarget(PartnerLinkTargets[key]);
    };
    PartnerLinkTarget.fromStringKey = function (key) {
        if (!PartnerLinkTarget.isValidKey(key)) {
            throw new Error("Unknown partner link target key '".concat(key, "'"));
        }
        return PartnerLinkTarget.fromKey(key);
    };
    PartnerLinkTarget.isValidKey = function (key) {
        return key in PartnerLinkTargets;
    };
    PartnerLinkTarget.fromValue = function (value) {
        return new PartnerLinkTarget(value);
    };
    PartnerLinkTarget.fromValues = function (values) {
        return values.map(function (value) { return new PartnerLinkTarget(value); });
    };
    PartnerLinkTarget.fromValuesUnique = function (values) {
        return PartnerLinkTarget.fromValues(__spreadArray([], __read(new Set(values)), false));
    };
    PartnerLinkTarget.fromString = function (value) {
        if (!PartnerLinkTarget.isValidValue(value)) {
            throw new Error("Unknown partner link target '".concat(value, "'"));
        }
        return new PartnerLinkTarget(value);
    };
    PartnerLinkTarget.isValidValue = function (value) {
        return Object.values(PartnerLinkTarget).includes(value);
    };
    PartnerLinkTarget.fromStrings = function (values) {
        return values.map(function (value) { return PartnerLinkTarget.fromString(value); });
    };
    PartnerLinkTarget.fromStringsUnique = function (values) {
        return PartnerLinkTarget.fromStrings(__spreadArray([], __read(new Set(values)), false));
    };
    PartnerLinkTarget.fromPaymentType = function (paymentType) {
        switch (paymentType) {
            case entity_1.PAYMENT_TYPE.ADDITIONAL:
            case entity_1.PAYMENT_TYPE.RECURRENT:
            case entity_1.PAYMENT_TYPE.SUBSCRIBE: return new PartnerLinkTarget(PartnerLinkTargets.Processor);
            case entity_1.PAYMENT_TYPE.FORMATION: return new PartnerLinkTarget(PartnerLinkTargets.Dawn);
            case entity_1.PAYMENT_TYPE.CONSULTATION: return new PartnerLinkTarget(PartnerLinkTargets.Indi);
            case entity_1.PAYMENT_TYPE.WIDGET: return new PartnerLinkTarget(PartnerLinkTargets.Widget);
            case entity_1.PAYMENT_TYPE.INDI: return new PartnerLinkTarget(PartnerLinkTargets.IndiProduct);
            case entity_1.PAYMENT_TYPE.INDI_SUBSCRIBE: return new PartnerLinkTarget(PartnerLinkTargets.ChronosPlus);
            case entity_1.PAYMENT_TYPE.COURSE:
            case entity_1.PAYMENT_TYPE.INDI_TRIAL: throw new Error("Target not implemented for this payment type '".concat(paymentType, "'"));
            default: throw new Error("Unknown payment type '".concat(paymentType, "'"));
        }
    };
    PartnerLinkTarget.prototype.toPaymentType = function () {
        switch (this._target) {
            case PartnerLinkTargets.Dawn: return entity_1.PAYMENT_TYPE.FORMATION;
            case PartnerLinkTargets.Processor: return entity_1.PAYMENT_TYPE.SUBSCRIBE;
            case PartnerLinkTargets.Widget: return entity_1.PAYMENT_TYPE.WIDGET;
            case PartnerLinkTargets.Indi: return entity_1.PAYMENT_TYPE.CONSULTATION;
            case PartnerLinkTargets.IndiProduct: return entity_1.PAYMENT_TYPE.INDI;
            case PartnerLinkTargets.ChronosPlus: return entity_1.PAYMENT_TYPE.INDI_SUBSCRIBE;
            default: throw new Error("Unknown target '".concat(this._target, "'"));
        }
    };
    PartnerLinkTarget.prototype.hasProducts = function () {
        return this.getProducts().length > 0;
    };
    PartnerLinkTarget.prototype.getProducts = function () {
        switch (this._target) {
            case PartnerLinkTargets.IndiProduct: return Object.values(indi_1.IndiProductCode);
            default: return [];
        }
    };
    PartnerLinkTarget.prototype.isValid = function () {
        return Object.values(PartnerLinkTarget).includes(this._target);
    };
    PartnerLinkTarget.prototype.isEqual = function (target) {
        return this.isSame(target._target);
    };
    PartnerLinkTarget.prototype.toString = function () {
        return this._target;
    };
    PartnerLinkTarget.prototype.toJSON = function () {
        return { target: this._target };
    };
    PartnerLinkTarget.prototype.isSame = function (value) {
        return value === this._target;
    };
    return PartnerLinkTarget;
}());
exports.PartnerLinkTarget = PartnerLinkTarget;
